import CalendarViewSelector from './CalendarViewSelector';
import PeriodNavigator from './PeriodNavigator';
import WeekCalendar from './WeekCalendar';
import MonthCalendarCompact from './MonthCalendarCompact';
import { useCalendarView } from 'hooks/useCalendarView';
import { useCalendarActions } from 'providers/CalendarSolc/CalendarActionsProvider';
import { useSolicitudes } from 'providers/SolicitudesProvider';

const CalendarWidget = () => {
  const { view, setView } = useCalendarView();
  const { selectedDay, handleSelectDay } = useCalendarActions();
  const { data } = useSolicitudes();

  const weekStart = selectedDay.startOf('isoWeek');

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <PeriodNavigator view={view} selectedDay={selectedDay} onChange={handleSelectDay} />
        <CalendarViewSelector value={view} onChange={setView} />
      </div>

      {view === 'week' ? (
        <WeekCalendar
          weekStart={weekStart}
          selectedDay={selectedDay}
          onSelectDay={handleSelectDay}
          data={data}
        />
      ) : (
        <MonthCalendarCompact selectedDay={selectedDay} onSelectDay={handleSelectDay} data={data} />
      )}
    </div>
  );
};

export default CalendarWidget;
